import store from "../../store";
import {httpReq} from "@/htttpReq";
import router from "@/router";

export default {
  namespaced: true,

  state: {
    totalPrice: {}
  },

  getters: {
    totalPrice(state) {
      return state.totalPrice;
    }
  },

  mutations: {
    seTotalPrice(state, payload){
      state.totalPrice = payload;
    }
  },

  actions: {
    getTotalPrice({commit}) {
      httpReq.get('/order/settings/get-details',
        {
          params:{
            order_id: this.getters['orderPreview/id'],
          }
        }
      )
        .then(response => {
          commit('seTotalPrice', response.data.data);
        })
        .catch(error => {
          store.commit('errorsModal/openModal', error.response.data.errors);
        })
        .finally(() => {})
    },

    putMargin({state, dispatch}) {
      httpReq.put('order/settings/change-margin',
        {
          order_id: this.getters['orderPreview/id'],
          value: state['totalPrice'].margin,
        }
      )
        .then(response => {
          if(response.status === 200){
            dispatch('getTotalPrice');
            store.dispatch('orderPreview/getPreview', true);
          }
        })
        .catch(error => {
          store.commit('errorsModal/openModal', error.response.data.errors);
        })
        .finally(() => {})
    },
  },
};
